import { BaseMediaClientError } from '../../models/errors';
export class FileFetcherError extends BaseMediaClientError {
  constructor(reason, id, metadata) {
    super(reason);
    this.reason = reason;
    this.id = id;
    this.metadata = metadata;
  }
  get attributes() {
    const {
      reason,
      id,
      metadata: {
        collectionName,
        occurrenceKey
      } = {}
    } = this;
    return {
      reason,
      id,
      collectionName,
      occurrenceKey
    };
  }
}
export function isFileFetcherError(err) {
  return err instanceof FileFetcherError;
}